/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/AwardsAchievementsMenu',['pixi', 'absolute', 'lodash', 'MenuUI/MenuTab', 'gameconfig', 'MenuUI/Menu',
        'MenuUI/ChallengeTile',
        'Solitaire/SolitaireGameMode',
        'MenuUI/YearAwardsTile',
        'MenuUI/ControlFocusManager',
        'Solitaire/MvvmStructure/Service/SolitaireDailyChallengeService'
    ],
    function (PIXI, Absolute, _, MenuTab, GameConfig, Menu, ChallengeTile, SolitaireGameMode,
              YearAwardsTile, ControlFocusManager,
              SolitaireDailyChallengeService) {

        var AwardsAchievementsMenu = function (ui, game) {

            if (window.addEventListener) {
                window.addEventListener("mousewheel", this.doScroll.bind(this), false);
                window.addEventListener("DOMMouseScroll", this.doScroll.bind(this), false);
            } else {
                window.attachEvent("onmousewheel", this.doScroll.bind(this));
            }

            if (this.scrollable) this.removeChild(this.scrollable);
            this.initialize(ui, game);
        };

        AwardsAchievementsMenu.prototype = Object.create(Absolute.Screen.prototype);

        AwardsAchievementsMenu.prototype.loadArtAssets = function (onSuccess, onError) {
            var levelLoader = new Absolute.Loader(),
                atlases = [{name: 'aw_menu'}];
            levelLoader.loadAtlases(atlases,
                function (percentComplete) {
                    Absolute.Debug.log('loading awards menu assets ', percentComplete);
                }.bind(this),
                onSuccess,
                onError);
        };

        AwardsAchievementsMenu.prototype.initialize = function (ui, game) {

            Absolute.Screen.call(this);

            this.ui = ui;
            this.game = game;

            this.controlFocusManager = new ControlFocusManager();

            var background = PIXI.Sprite.fromFrame('win10_MS_bg.png');
            this.background.addChild(background);
        };


        AwardsAchievementsMenu.prototype.onShow = function () {
            this.ui.showLoadingScreen();
            if (!this.artInitialized) {
                this.loadArtAssets(
                    function () {
                        this.artInitialized = true;
                        this.completeInit();
                    }.bind(this),
                    function () {}
                );
            }
            else {
                this.completeInit();
            }

        };

        AwardsAchievementsMenu.prototype.completeInit = function () {
            if (this.menu) {
                this.menu.onShow();
            }
            this.addChild(this.game.menuBar);
            this.initData();
            this.ui.hideLoadingScreen();
            this.game.menuBar.onShow(true, true);
        };

        AwardsAchievementsMenu.prototype.initData = function () {
            if (this.menu) {
                this.removeChild(this.menu);
            }
            if(this.scrollable) {
                this.removeChild(this.scrollable);
            }
            var data = SolitaireDailyChallengeService.GetChallengesData();
            this.scrollable = new PIXI.DisplayObjectContainer();
            var tiles = [];
            for (var year in data) {
                tiles.push(new YearAwardsTile({}, data[year], year, this));
            }
            var menu = new Menu({
                'tiles': tiles,
                'label': Absolute.StringManager('DailyChallenge.dc'),
                'tilePaddingX': Absolute.Coords.x(30)
            });
            menu.x = Absolute.Coords.x(90);
            menu.y = Absolute.Coords.y(170);
            this.scrollable.addChild(menu);
            this.addChild(this.scrollable);
        };

        AwardsAchievementsMenu.prototype.doScroll = function (e) {
            if (!this.scrollable || this.scrollable.height < Absolute.Coords.y(900)) return;
            var deltaY = 0;
            if (!e) e = window.event;
            if (e.wheelDelta) {
                deltaY = e.wheelDelta / 15;
            } else if (e.detail) {
                deltaY = -e.detail / 3;
            }
            this.scrollable.y = this.scrollable.y + (deltaY * 100);
            if (this.scrollable.y > 0) this.scrollable.y = 0;
            if (Math.abs(this.scrollable.y) > this.scrollable.height - Absolute.Coords.y(900)) {
                this.scrollable.y = -(this.scrollable.height - Absolute.Coords.y(900));
            }
            e.preventDefault();
        };

        AwardsAchievementsMenu.prototype.handleYearSelect = function (year) {
            this.game.navAwards(year);
        };

        AwardsAchievementsMenu.prototype.handleCommand = function (command) {
            switch (command) {
                case 'Right':
                    this.controlFocusManager.focusNextControl(1);
                    break;
                case 'Left':
                    this.controlFocusManager.focusNextControl(-1);
                    break;
                case 'Activate':
                    this.controlFocusManager.activateCurrentControl();
                    break;
            }
        };


        return AwardsAchievementsMenu;

    });
